import { NAVIGATION, SUB_NAVIGATION_HEADER } from '@utils/constants';
import cx from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import * as styles from './Navigation.module.css';

import Grid from '@components/SVG/Grid';

const Navigation = ({
	setShowModal,
	className = '',
}: {
	setShowModal: (value: boolean | ((prevVar: boolean) => boolean)) => void;
	className?: string;
}): JSX.Element => {
	return (
		<>
			<nav
				className={cx(styles.navigation, {
					[className]: !!className,
				})}
				aria-label="Primary menu">
				<ul className={styles.list}>
					{NAVIGATION.map(({ label, to, onClick, icon }, key) => {
						let iconToUse;

						switch (icon) {
							case 'grid':
								iconToUse = (
									<Grid className={styles.iconGrid} />
								);
								break;
							case 'arrow':
								iconToUse = null;
							default:
								break;
						}

						return onClick ? (
							<li key={key}>
								<button
									className={styles.link}
									onClick={() => setShowModal(true)}>
									{label}
									{iconToUse}
								</button>
							</li>
						) : (
							<li key={key}>
								<Link to={to} className={styles.link}>
									{label}
									{iconToUse}
								</Link>
							</li>
						);
					})}
				</ul>
			</nav>

			<nav
				className={cx(styles.subNavigation, styles.navigation)}
				aria-label="Secondary menu">
				<ul className={styles.list}>
					{SUB_NAVIGATION_HEADER.map(({ label, to }, key) => {
						return (
							<li key={key}>
								<Link to={to} className={styles.link}>
									{label}
								</Link>
							</li>
						);
					})}
				</ul>
			</nav>
		</>
	);
};

export default Navigation;
